import { RiCommunityLine } from "@itandi/itandi-bb-ui";
import { useState } from "react";
import { DealVendorChangeModal } from "~/components/common/deals/show/vendor_card/DealVendorChangeModal";
import { EditMenuButton } from "~/components/common/parts/button/EditMenuButton";
import { useVendorSessionContext } from "~/context/VendorSession";
import type { Deal } from "~/models/Deal";
import {
	getOriginDealVendor,
	isOriginVendor
} from "~/models/DealVendorCompany";
import Styles from "../DealCard.module.scss";

type Props = {
	deal: Deal;
};

/**
 * 管理会社から依頼をうけた施工会社の情報を表示する。
 * Vendorが2次請け構造のとき、1次請けの施工会社情報を表示する
 *
 * @constructor
 * @for vendor
 */
export function DealOriginVendorCard({ deal }: Props) {
	const [isOpen, setIsOpen] = useState(false);
	const session = useVendorSessionContext();
	const dealVendor = getOriginDealVendor(deal);

	if (dealVendor === null) {
		return null;
	}

	return (
		<div className={Styles.DealCard}>
			<h3 className={Styles.Title}>
				<RiCommunityLine className={Styles.TitleIcon} />
				案件依頼先情報
				{isOriginVendor(deal, session.vendorCompany.id) && (
					<div className={Styles.EditButtonWrapper}>
						<EditMenuButton
							onClick={() => {
								setIsOpen(true);
							}}
						>
							変更
						</EditMenuButton>
						{isOpen ? (
							<DealVendorChangeModal
								dealVendorCompany={dealVendor}
								handleClose={() => {
									setIsOpen(false);
								}}
							/>
						) : null}
					</div>
				)}
			</h3>
			<div className={Styles.Content}>
				<dl className={Styles.ListContent}>
					<dt className={Styles.ListContentCaption}>会社名</dt>
					<dd className={Styles.ListContentValue}>
						{dealVendor.vendorCompany?.name}
					</dd>
				</dl>
				<dl className={Styles.ListContent}>
					<dt className={Styles.ListContentCaption}>担当者</dt>
					<dd className={Styles.ListContentValue}>
						{dealVendor.user === null ? (
							<span className={Styles.NotYet}>未定</span>
						) : (
							<>
								<div>{dealVendor.user.name}</div>
								<div>
									<a
										className={Styles.Link}
										href={`tel:${dealVendor.user.tel}`}
									>
										{dealVendor.user.tel}
									</a>
								</div>
								<div>
									<a
										className={Styles.Link}
										href={`mailto:${dealVendor.user.email}`}
									>
										{dealVendor.user.email}
									</a>
								</div>
							</>
						)}
					</dd>
				</dl>
			</div>
		</div>
	);
}
